import { render, staticRenderFns } from "./capsule-line.vue?vue&type=template&id=58c67cf8&scoped=true&"
import script from "./capsule-line.vue?vue&type=script&lang=js&"
export * from "./capsule-line.vue?vue&type=script&lang=js&"
import style0 from "./capsule-line.vue?vue&type=style&index=0&id=58c67cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c67cf8",
  null
  
)

export default component.exports